/* Nakylo · carrousels mobiles des groupes (réglage « Disposition sur mobile » = défiler).
   Une carte par écran ; sous le carrousel, flèches et points : le point actif suit le défilement au doigt,
   un point ou une flèche fait défiler jusqu'à la carte. Rien n'apparaît sur ordinateur (CSS). Textes d'aide
   lus par les lecteurs d'écran : clés Dawn traduites (general.slider.*), passées par le bloc. */
(function () {
  if (window.nkyDefiler) return;
  window.nkyDefiler = true;
  var FLECHE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M14.5 6 8.5 12l6 6"/></svg>';

  function brancher(g) {
    if (g.dataset.nkyDefilerPret) return;
    var cartes = Array.prototype.slice.call(g.children);
    if (cartes.length < 2) return;
    g.dataset.nkyDefilerPret = '1';
    g.setAttribute('role', 'region');
    g.setAttribute('aria-roledescription', g.dataset.nom || 'Carrousel');

    var nav = document.createElement('div');
    nav.className = 'nky-defiler-nav';
    var prec = document.createElement('button'), suiv = document.createElement('button');
    prec.type = suiv.type = 'button';
    prec.className = 'nky-defiler-nav__fleche'; suiv.className = 'nky-defiler-nav__fleche nky-defiler-nav__fleche--suiv';
    prec.innerHTML = suiv.innerHTML = FLECHE;
    prec.setAttribute('aria-label', g.dataset.precedent || '');
    suiv.setAttribute('aria-label', g.dataset.suivant || '');
    var points = document.createElement('div');
    points.className = 'nky-defiler-nav__points';
    var boutons = cartes.map(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'nky-defiler-nav__point';
      b.setAttribute('aria-label', (i + 1) + ' ' + (g.dataset.sur || '/') + ' ' + cartes.length);
      b.addEventListener('click', function () { aller(i); });
      points.appendChild(b);
      return b;
    });
    nav.appendChild(prec); nav.appendChild(points); nav.appendChild(suiv);
    g.parentNode.insertBefore(nav, g.nextSibling);

    function actuel() {
      var milieu = g.scrollLeft + g.clientWidth / 2, meilleur = 0, ecart = Infinity;
      cartes.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - g.offsetLeft + c.offsetWidth / 2 - milieu);
        if (d < ecart) { ecart = d; meilleur = i; }
      });
      return meilleur;
    }
    function aller(i) {
      i = Math.max(0, Math.min(cartes.length - 1, i));
      g.scrollTo({ left: cartes[i].offsetLeft - cartes[0].offsetLeft, behavior: 'smooth' });
    }
    function maj() {
      var i = actuel();
      boutons.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      prec.disabled = i === 0; suiv.disabled = i === cartes.length - 1;
    }
    prec.addEventListener('click', function () { aller(actuel() - 1); });
    suiv.addEventListener('click', function () { aller(actuel() + 1); });
    var attente;
    g.addEventListener('scroll', function () { cancelAnimationFrame(attente); attente = requestAnimationFrame(maj); }, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  }
  function tout() { document.querySelectorAll('[data-nky-defiler]').forEach(brancher); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
  document.addEventListener('shopify:block:select', tout);
})();
